<template>
  <section class="myhome-wrap"
           v-if="isInit">
    <nav class="myhome-inb">
      <div class="fclt-nm-tit __center"
           style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
        {{ fcltyNm }}
        <div>
        <btn :txt="'시설 변경'"
             :size="'ssmall'"
             @click="btnFcltyChng_click"/>
        </div>
      </div>
      <ul>
        <!-- 활성화 영역 클래스 current -->
        <li v-for="{cd, nm, img} in parents"
            :key="'parent_' + cd"
            :class="parentCd == cd ? 'current': ''"
            @click="parent_click(cd)">
          <a href="javascript:;" class="article-title no-child">
            <span class="material-icons mgr5" style="vertical-align: middle;">{{ img }}</span>
            {{ nm }}
          </a>
        </li>
      </ul>
    </nav>
    <section class="myhome-con">
      <component :is="contentComponent" :fclty-sn="props.fcltySn"/>
    </section>
  </section>
</template>

<script setup>
import DirctInqry from '@/views/my-home/dirct-inqry.vue';
import FcltyDp from '@/views/my-home/fclty-dp.vue';
import FcltyMberMng from '@/views/my-home/fclty-mber-mng.vue';
/*import SancDl from "@/views/my-home/sanc-dl.vue";*/
import SvcReqstDl from "@/views/my-home/svc-reqst-dl.vue"
import YetdSvcReqstDl from "@/views/my-home/yetd-svc-reqst-dl.vue"
import MyHome from "@/views/my-home/my-home.vue";
/*import MssgMng from "@/views/my-home/mssg-mng.vue";*/
import StlmMnMng from "@/views/my-home/stlm-mn-mng.vue";

import {computed, defineProps, markRaw, nextTick, onMounted, ref, defineEmits} from "vue";

import {getUtils} from "@/utils/import";
const {$popup, $cmmnPopup, $cmmn} = getUtils();

const props = defineProps({
  fcltySn: Number
});

let contentComponent = ref(null);

const menus = ref([
  { cd:'100', nm: '시설상세정보', lvl: 1, img: 'business', component: markRaw(FcltyDp) },
  { cd:'800', nm: '결제수단관리', lvl: 1, img: 'payments', component: markRaw(StlmMnMng) },
  { cd:'200', nm: '서비스신청내역', lvl: 1, img: 'assignment', component: markRaw(SvcReqstDl) },
  { cd:'700', nm: '연말정산신청내역', lvl: 1, img: 'assignment', component: markRaw(YetdSvcReqstDl) },
  /*{ cd:'300', nm: '결제내역', lvl: 1, img: 'paid', component: markRaw(SancDl) },*/
  { cd:'400', nm: '시설회원관리', lvl: 1, img: 'groups', component: markRaw(FcltyMberMng) },
  { cd:'500', nm: '1:1 문의', lvl: 1, img: 'question_answer', component: markRaw(DirctInqry) },
  /*{ cd:'600', nm: '문자관리', lvl: 1, img: 'question_answer', component: markRaw(MssgMng) },*/
]);

const parentCd = ref(null);
const parents = computed(() => menus.value.filter(({lvl}) => lvl == 1));
const parent_click = (selCd) => {
  if (parentCd.value == selCd) return false;
  parentCd.value = selCd;
  const menu = menus.value.find(({cd}) => cd == selCd);
  contentComponent.value = menu.component;
}

const fcltyNm = ref('');
const bzno = ref('');
const getFcltyByFcltySn = async () => {
  const data = await $cmmn.fclty.getFcltyByFcltySn(props.fcltySn);
  fcltyNm.value = data.fcltyNm;
  bzno.value = data.bzno;
}

const emits = defineEmits(['close']);
const btnFcltyChng_click = () => {
  emits('close');

  $cmmnPopup.fcltyChocShow(openFcltSvcPopup);
 }

const openFcltSvcPopup = ({fcltySn}) => {
  const popupOpts = {
    header: '시설 및 서비스',
    contentStyle: {
      'width': '1200px',
      'max-height': '660px',
      'overflow': 'auto',
      'background': '#f9f5ff'
    }
  };

  const props = { fcltySn };

  $popup.show(MyHome, popupOpts, props);
}

const isInit = ref(false);
onMounted( () => {
  nextTick(async () => {
    await getFcltyByFcltySn();
    parent_click('100');
    isInit.value = true;
  })
})
</script>

<style scoped>
.fclt-nm-tit {
  background: #fafafa;
  height: 60px;
  line-height: 30px;
  border-bottom: 1px solid #e0e0e0;
}
</style>
